import { exeRequest } from '../utils/APIUtils'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    recupererListeVehicules: async () => exeRequest(`/admin/liste-vehicule`, "GET"),
    statsInscriptionsVehicules: async (periode = 'jour') => exeRequest(`/admin/stats-inscriptions-vehicules?periode=${periode}`, "GET"),
    statsClassesServices: async (periode = 'jour') => exeRequest(`/admin/stats-classes-services?periode=${periode}`, "GET"),
    getById: async (id) => exeRequest(`/admin/vehicule/${id}`, "GET"),
    update: async (id, data) => exeRequest(`/admin/vehicule/${id}`, "PUT", data),
}